export default __webpack_public_path__ + "media/images/images_v2/bordright-onglet2-ea6c0ac09c8d26d6e68ddcff9eb8040c.png";